export function resolveAssessmentAssignableName(
  reminderOnType: string | null | undefined,
  reminderOnId: string | number | null | undefined,
  assessments: { id: number; name: string }[],
  sequences: { id: number; name: string }[]
): string | null {
  if (!reminderOnId) return null;

  const id = reminderOnId.toString();

  if (reminderOnType === 'Grouping') {
    return sequences.find((sequence) => sequence.id.toString() === id)?.name ?? null;
  }

  return assessments.find((assessment) => assessment.id.toString() === id)?.name ?? null;
}
